import { Component, Input, OnInit, Optional } from '@angular/core';
import { UntypedFormControl, FormGroupDirective, NgForm, ValidationErrors } from '@angular/forms';
import { ErrorControlDirective } from '../error-control.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'forms-input-textarea',
  templateUrl: './input-textarea.component.html',
  styleUrls: ['./input-textarea.component.scss'],
})
export class InputTextareaComponent extends ErrorControlDirective implements OnInit {
  @Input() control: UntypedFormControl;
  @Input() tooltip: string;
  @Input() placeholder: string;
  @Input() maxLength: string;
  @Input() required: boolean;
  @Input() bottomSpacing?: 'default' | 'small' | 'none' | false = 'default';

  constructor(
    @Optional() _parentForm: NgForm,
    @Optional() _parentFormGroup: FormGroupDirective,
    private translateService: TranslateService,
  ) {
    super(_parentForm, _parentFormGroup);
  }

  ngOnInit(): void {
    if (!this.errorMessages.maxlength) {
      this.errorMessages.maxlength = (err: ValidationErrors) => {
        return this.translateService.instant('FRONTEND.FORMS.INPUT.MAXIMUM_LENGTH', { maxLength: err.requiredLength });
      };
    }

    if (!this.errorMessages.minlength) {
      this.errorMessages.minlength = (err: ValidationErrors) => {
        return this.translateService.instant('FRONTEND.FORMS.INPUT.MINIMUM_LENGTH', { minLength: err.requiredLength });
      };
    }
  }
}
